
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import type { Block } from "../types";

interface TextBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
}

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'clean']
  ]
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet',
  'link'
];

export const TextBlock = ({ block, onUpdate }: TextBlockProps) => {
  return (
    <div className="prose prose-sm max-w-none">
      <ReactQuill
        theme="snow"
        value={block.content}
        onChange={(content) => onUpdate({ content })}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};
